<template>
  <ul class="flex text-gold text-2xl mt-2 mb-6 md:mt-3 md:relative mx-auto">
    <li
      v-for="(network, index) in Object.keys(socialProfiles)"
      :key="index"
      class="ml-2"
    >
      <a
        :href="socialProfiles[network]"
        target="_blank"
        rel="noopener"
        :title="network"
      >
        <i :class="`icon-${network}`" />
      </a>
    </li>
  </ul>
</template>

<script>
export default {
	name: "SocialNetworks",

	computed: {
		socialProfiles() {
			return this.$store.state.App.socialProfiles;
		}
	}
};
</script>